
export default {
  name: 'SectorTag',
  props: {
    data: Array,
  },
}
